import { connect } from "react-redux";
import App from "../../components/App/App";
import { withRouter } from "../../components/WithRouter/WithRouter";

export const mapStateToProps = () => ({})

export default withRouter(connect(mapStateToProps)(App))